<div class="wrapper overflow-auto fixed top-0 left-0 w-full h-full grid place-items-center z-10">
  <div class="m-4">
    <img
      class="mx-auto mb-6 h-14"
      [src]="'./assets/' + clientData.name + '-logo.svg'"
      [alt]="clientData.name + ' Logo'" />
    <form
      class="sm:w-[30rem] w-auto flex flex-col p-8 gap-4 bg-[var(--sco-color-white)] rounded-xl"
      (ngSubmit)="login()">
      <h3 class="text-center">{{ 'LOGIN_TITLE' | translate }}</h3>
      <div>
        <sco-input
          type="text"
          name="uname"
          label="{{ 'USERNAME' | translate }}"
          class="grow rounded-l-lg"
          [ngClass]="{ isNotValid: !validUsername }"
          [(ngModel)]="username"></sco-input>
      </div>

      <div>
        <sco-input
          type="password"
          name="psw"
          label="{{ 'PASSWORD' | translate }}"
          class="grow rounded-l-lg pt-1"
          [ngClass]="{ isNotValid: !validPassword }"
          [(ngModel)]="password"></sco-input>
        <div class="flex justify-end py-2">
          <a class="text-sm" [href]="links.PASSWORD_FORGOTTEN"> {{ 'PASSWORD_FORGOTTEN' | translate }} </a>
        </div>
      </div>

      <button scoButton type="submit" [disabled]="isLoggingIn">{{ 'LOGIN' | translate }}</button>
      <button scoButton variant="outline" (click)="openLink(links.REGISTER)">{{ 'REGISTER' | translate }}</button>
    </form>
  </div>
</div>
